import { getEngine } from '@lio/rule-engine';

import { isNotProduction } from '@utils/isInLowerEnv';
import { enqueueSnackbar } from 'notistack';

type ExecuteArg = Parameters<ReturnType<typeof getEngine>['execute']>[0];
type ExecuteOptions = Parameters<ReturnType<typeof getEngine>['execute']>[1];
type AttributeType<Key extends string> = { [key in Key]: ExecuteArg } & { codeName: string };

export function safeExecuteRuleEngine<K extends string, A extends AttributeType<K>>(
  ruleEngine: ReturnType<typeof getEngine>,
  attributeType: A,
  key: K,
  options?: ExecuteOptions,
) {
  try {
    return ruleEngine.execute(attributeType[key], options);
  } catch (error) {
    const message = `${attributeType.codeName}: I had an uncaught error while executing ${key.toString()}, please log a bug`;
    if (isNotProduction()) {
      enqueueSnackbar(message, {
        variant: 'debug-info',
        autoHideDuration: 5000,
        persist: true,
        preventDuplicate: true,
      });
    }
    console.error(message, error);
    throw error; // Re-throw the error after alerting
  }
}
